var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "time-field"
  }, [_c('DatePicker', {
    staticClass: "date-picker",
    attrs: {
      "placeholder": _vm.label,
      "clearable": false,
      "type": "time",
      "format": "HH-mm",
      "disabled-time": _vm.disabledDates
    },
    on: {
      "change": _vm.updateTime
    },
    model: {
      value: _vm.localTime,
      callback: function callback($$v) {
        _vm.localTime = $$v;
      },
      expression: "localTime"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }